import React from 'react';
import cn from 'classnames';

import { selectRoomDbData } from 'client/redux/room/selectors';
import { useTranslation, useAppSelector } from 'client/hooks';
import { useLiveStreamContext } from 'client/components/LiveStreamConnector/context';

import { USER_ROLES, ROOM_STATUS } from 'constants/index';

import Icon from '../../../../Icon';

import css from './BroadcastButton.module.scss';

interface Props {
  userRole: USER_ROLES;
  isBroadcasting: boolean;
  color?: string;
  isRoomFinished?: boolean;
}

const BroadcastButton: React.FC<Props> = (props) => {
  const { userRole, isBroadcasting, isRoomFinished = false } = props;
  const { translate } = useTranslation('actionsPanel');
  const roomData = useAppSelector(selectRoomDbData);
  const roomStatusClosed = roomData?.status === ROOM_STATUS.INACTIVE;
  const { state } = useLiveStreamContext();
  const { isBusy: liveStreamIsBusy } = state;

  return (
    <>
      <div className={css.iconWrapper}>
        {userRole === USER_ROLES.HOST ? (
          <>
            {isRoomFinished ? (
              <Icon color="#999999" type="recording-helper" className={css.iconEnd} />
            ) : (
              <Icon
                type={isBroadcasting ? 'broadcast-end-sm' : 'broadcast-start-l'}
                className={isBroadcasting ? css.iconEnd : css.iconStart}
              />
            )}
          </>
        ) : (
          <Icon
            type={isBroadcasting ? 'broadcast-end-l' : 'broadcast-start-l'}
            className={css.iconBroadCastAdmin}
            color={isRoomFinished ? '#999999' : ''}
          />
        )}
      </div>

      {!liveStreamIsBusy && (
        <div
          className={cn(css.name, userRole === USER_ROLES.HOST && css.forHostPanel, roomStatusClosed && css.isClosed)}
        >
          {isBroadcasting ? translate('btns.finishBroadcastBtn') : translate('btns.startBroadcastBtn')}
        </div>
      )}

      {liveStreamIsBusy && (
        <div
          className={cn(css.name, userRole === USER_ROLES.HOST && css.forHostPanel, roomStatusClosed && css.isClosed)}
        >
          {isBroadcasting ? translate('btns.stoppingBroadcast') : translate('btns.startingBroadcast')}
        </div>
      )}
    </>
  );
};

export default BroadcastButton;
